import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Departamento, DetallesCapis } from '../utils/utils';
import logoPrivadas from "../assets/images/ubicacionPrivadas.png"
import logoPatronales from "../assets/images/ubicacionPatronales.png"
import logoPublicas from "../assets/images/ubicacionPublicas.png"
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function MapaCapisInv() {

  const departamentosEstaticos = [
    ["Santa Ana", "San Salvador", "Cuscatlán", "San Miguel"],
    ["Ahuachapán", "La Libertad", "Cabañas", "Usulután"],
    ["Sonsonate", "Chalatenango", "La Paz", "La Unión"],
    ["", "", "San Vicente", "Morazán"]
  ];

  const [capis, setCapis] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(null)
  const [departamentos, setDepartamentos] = useState([]);
  const navigate = useNavigate();

  async function getCapis() {
    let capis = await DetallesCapis();
    console.log(capis);
    setCapis(capis);
  }

  async function getDepartamentos() {
    let data = await Departamento(); // Asegúrate de que devuelve datos en formato esperado
    console.log("Datos de departamentos:", data);

    const datosMapeados = {};
    data.forEach(dep => {
      datosMapeados[dep.name] = dep.id;
    });

    setDepartamentos(datosMapeados); // Ahora departamentos es un objeto { name: id }
  }

  useEffect(function () {
    getCapis();
    getDepartamentos();
  }, []);


  const [capisPorDepartamento, setCapisPorDepartamento] = useState({});

  async function getCapisPorDepartamento() {
    if (!departamentos || Object.keys(departamentos).length === 0) return;

    const promesas = Object.entries(departamentos).map(async ([name, id]) => {
      try {
        const response = await axios.get(`https://capis-fundemas.ticongle.com/backend/public/api/capisDept/${id}`);
        return { name, count: response.data.count }; // Guarda el name y la cantidad
      } catch (error) {
        console.error(`Error al obtener datos de ${name}:`, error);
        return { name, count: 0 }; // Si falla, asigna 0 CAPI
      }

    });

    // Espera todas las peticiones y crea un objeto { departamento: cantidad }
    const resultados = await Promise.all(promesas);
    const capisMapeados = {};
    resultados.forEach(dep => {
      capisMapeados[dep.name] = dep.count;
    });
    console.log("Datos obtenidos de la API:", capisMapeados);
    setCapisPorDepartamento(capisMapeados);
  }

  useEffect(() => {
    if (Object.keys(departamentos).length > 0) {
      getCapisPorDepartamento();
    }
}, [departamentos]);

  const icons = {
    Privado: L.icon({
      iconUrl: logoPrivadas,
      iconSize: [38, 38],
    }),
    Patronal: L.icon({
      iconUrl: logoPatronales,
      iconSize: [38, 38],
    }),
    Publico: L.icon({
      iconUrl: logoPublicas,
      iconSize: [38, 38],
    })
  }

  // const CenterMap = ({ position }) => {
  //     const map = useMap();
  //     useEffect(() => {
  //       if (position) {
  //         map.flyTo(position, 12); // Cambia el centro del mapa con una animación
  //       }
  //     }, [position, map]);
  //     return null;
  //   };

  const handleDepartamentoClick = (name) => {
    console.log("Departamento clickeado:", name);
    console.log("ID encontrado:", departamentos[name]);
    const id = departamentos[name];
    if (id) {
      navigate(`/Beneficiario_DetallesDepto/${id}`);
    }
  };

  return (
    <div className="mt-14 ml-32 w-auto ml-28 mr-6">
      <div className="flex flex-col mb-2">
        <h1 className="text-4xl font-bold text-[#0E7FA0] text-center mb-4">Localización de centros CAPI</h1>
        <MapContainer center={[13.794599, -88.93]} zoom={9}>
          <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
          {/* <CenterMap position={selectedPosition} /> */}

          {capis.map(capi => (
            <Marker
              key={capi.id_autorizacion}
              position={[capi.latitud, capi.longitud]}
              icon={icons[capi.naturaleza] || icons.Publico}
              eventHandlers={{
                click: () => setSelectedPosition([capi.latitud, capi.longitud]),
              }}>
              <Popup>
                {capi.name_establecimiento} <br />
                Tipo: {capi.naturaleza}
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      <div>
        <table className='border p-2 table-auto border-collapse w-full rounded-2xl'>
          <thead className='bg-[#0E7FA0] text-white font-bold'>
            <tr>
              <th className='border p-2'>Zona Oriental</th>
              <th className='border p-2'>Zona Central</th>
              <th className='border p-2'>Zona Paracentral</th>
              <th className='border p-2'>Zona Occidental</th>
            </tr>
          </thead>
          <tbody className='text-center bg-[#A9DDE9]'>
            {departamentosEstaticos.map((fila, rowIndex) => (
              <tr key={rowIndex}>
                {fila.map((departamento, colIndex) => (
                  <td
                    key={colIndex}
                    className={`border p-2 ${departamento ? 'cursor-pointer hover:bg-[#0E7FA0] hover:text-white' : ''}`}
                    data-id={departamentos[departamento] || ""}
                    onClick={() => departamento && handleDepartamentoClick(departamento)}
                  >
                    {departamento}
                    {departamento && capisPorDepartamento[departamento] !== undefined && (
                      <span className="block text-base w-auto">
                        {capisPorDepartamento[departamento]}
                      </span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default MapaCapisInv;
